import store from "@/store"
import { jsonp } from "vue-jsonp"
import { Dialog } from "vant"

// 直辖市市级码=前2位+00（北京1100/天津1200/上海3100/重庆5000），与后端 PcaCode.MUNICIPALITY
// / RegionCodeUtil.region_code_00 口径一致；逆地理编码返回区级 adcode（如重庆 500108），
// 必须归一到市级码，否则门店/商品 SQL city_code LIKE 前缀匹配漏匹配
var MUNICIPALITY_PREFIXES = ['11', '12', '31', '50']
var adcodeToCityCode = function (adcode) {
  if (!adcode) return ''
  var s = String(adcode)
  return MUNICIPALITY_PREFIXES.some(function (p) { return s.startsWith(p) })
    ? s.substring(0, 2) + '00'
    : s.substring(0, 4)
}

var change_city_by_location = function (lat, lng) {
  // lng = 106.45; lat = 29.56 // 重庆的

  var city_name = store.getters.city_name;
  budo_log.debug("#3 change_city_by_location", city_name, lat, lng)

  // 用户拒绝切换城市
  if (sessionStorage.getItem("budo.user_no_change_city")) {
    budo_log.info("#10 budo.user_no_change_city, return")
    return
  }

  // 未获取到经纬度
  if (!lat || !lng) {
    budo_log.debug("#16 change_city_by_location", city_name, lat, lng)
    return
  }

  // 经纬度转城市
  jsonp(`https://apis.map.qq.com/ws/geocoder/v1/`, {
    output: "jsonp",
    key: "VGZBZ-MACHK-DTQJB-ACE53-W2BZE-CKF3T",
    location: `${lat},${lng}`
  }).then(res => {
    budo_log.debug("#12 map geocoder", res);

    var city = res?.result?.ad_info?.city

    if (city && city_name != city) {
      // 还未快速切换过 快速切换一次 后面再切换就需确认了
      if (!sessionStorage.getItem("budo.user_change_city_confirm")) {
        budo_log.info("#36 geocoder SET_CITY_NAME", res)

        store.commit("SET_CITY_CODE", adcodeToCityCode(res?.result?.ad_info?.adcode))
        store.commit("SET_CITY_NAME", city)

        sessionStorage.setItem("budo.user_change_city_confirm", true) // 后面再切换就需确认了
        location.reload()
        return
      }

      Dialog.confirm({
        title: "切换城市",
        message: `定位到您在${city},是否切换?`
      }).then(() => {
        budo_log.info("#48 geocoder SET_CITY_NAME", res)

        store.commit("SET_CITY_CODE", adcodeToCityCode(res?.result?.ad_info?.adcode))
        store.commit("SET_CITY_NAME", city)
        location.reload()
      }).catch(() => {
        sessionStorage.setItem("budo.user_no_change_city", "true") // 用户拒绝切换城市 存在 sessionStorage 下次进来就没了
        location.reload()
      });
    }
  });
}

var isIos = function () {
  const u = navigator.userAgent;
  return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
}

var get_location_href = function () {
  if (isIos()) {
    return window['_location_href_'] || location.href
  }

  return location.href
}

export {
  change_city_by_location,
  get_location_href,
  adcodeToCityCode
}